const component = {
    login: { url: '/' },
    register: { url: '/recruit/client-registration-form' },

    campusJobMelaInvitationForm: { url: '/campus/job-mela/:slug' },


    dashboard: { url: '/dashboard' },
    postOppurtunity: { url: '/oppurtunity/post' },
    kycForm: { url: '/kyc' },
    databaseSearch: { url: '/search' },
    databaseSearchList: { url: '/searchList' },
    OppurtunityApplications: { url: '/oppurtunity/applications/:job_id' },
    viewProfile: { url: '/company/profile' },
    generateOffer: { url: '/generate-offer' },




    registrationAndPayment: { url: '/rCommerce/client/registrationAndPayment' },
    registrationAndPaymentMiddleware: { url: '/processing' },
    logout: { url: '/logout' },
    Register: { url: '/recruit/client-registration-form' },
    PrRegister: { url: '/Register/PrRegister' },
    JobPost: { url: '/JobPost/JobPost' },
    OnlineSalesEnquiry: { url: '/online-sales-enquiry' },
    TransactionHistory: { url: '/transaction/history' },
    TransactionInvoice: { url: '/transaction/invoice' },
    ForgotPassword: { url: '/password/forgot' },
    JobPosting: { url: '/subscriptions' },
    JobPackage: { url: '/job-package' },
    EditProfile: { url: '/profile/edit' },
    // JobPosting: { url: '/JobPosting' },
    resetPassword: { url: '/reset-password' },
    package: { url: '/package/select' },
    PostAJob: { url: '/post/job' },
    JobList: { url: '/list/posted-job' },
    PostARegularJob: { url: '/post/job/regular' },
    PostAFeaturedJob: { url: '/post/job/featured' },
    PostAPremiumJob: { url: '/post/job/premium' },
    PostACampusJob: { url: '/post/job/campus' },
    PostInternship: { url: '/post/internships' },
    EditCampusJob: { url: '/edit/campus-job' },
    EditInternship: { url: '/edit/internships' },
    JobApplicationList: { url: '/portal/job/applications' },
    CampusJobApplicationList: { url: '/campus/job/applications' },
    CampusInternshipApplicationList: { url: '/campus/internship/applications' },
    updateKyc: { url: '/kyc/update' },

    editJob: { url: '/edit/portal-job' },
    // zoomMeeting: { url: '/zoom/meet' },
    RecruiterGuidelines: { url: '/guidelines' },
    directjobpost: { url: '/job-post' },
    LOI: { url: '/letter-of-intent' },
    Page404: { url: '/404' },
    ThankYou: { url: '/thank-you' },
    ChangePassword: { url: '/Change-Password' },
    Settings: { url: '/Settings' },
    Security: { url: '/Security' },
    // updateSecurityCode: { url: '/update/security-code' },
    // UpdatePin: { url: '/UpdatePin' },
    ManageSubusers: { url: '/manage-subusers' },
    UserCreate: { url: '/user-create' },
    UserList: { url: '/user-list' },
    UserUpdate: { url: '/user-update/:id' },
    // successfullyPackagePurchased: { url: '/subscription/success' },
    // BuyPackage: { url: '/Buy-Package' },
    SuccessPayment: { url: '/success-payment' },
    PaymentFailse: { url: '/payment-failed' },
    PaymentProcessing: { url: '/payment' },
    onBoardCandidate: { url: '/onboard' },
    contactUs: { url: '/contact-us' },
    // eventCalender: { url: '/event-calender' },
    // futureHiringList: { url: '/future-hiring-list' },
    candidateSearch: { url: '/candidate/search' },
    addCandidate: { url: '/candidate/add' },
    campusJobList: { url: '/campus/list/job' },
    campusInternshipList: { url: '/campus/list/internship' },


    campusDriveDashboard: { url: '/campus-drive' },
    campusDriveStudentPanel: { url: '/campus-drive/student-panel/:id' },




}

const title = {
    HomePage: "JobzShala - Your Ultimate Recruitment Solution with Employer's Login",
    Register: "Unlock Powerful Recruitment Solutions - Employer's Registration at JobzShala",
    SalesEnquiry: "Explore Our Services - Sales Enquiry at JobzShala",
    OnlineSalesEnquiry: "Conveniently Inquire Online - Online Sales Enquiry at JobzShala",
    ForgotPassword: "Regain Access - Reset Recruiter's Password at JobzShala",
    PostRegularJob: "Share Regular Opportunities - Post Regular Job at JobzShala",
    PostFeaturedJob: "Highlight Your Vacancy - Post Featured Job at JobzShala",
    PostPremiumJob: "Maximize Visibility - Post Premium Job at JobzShala",
    ForgetPassword: "Retrieve Access - Reset Recruiter's Password at JobzShala",
    package: "Tailored Solutions - Employer's Packages at JobzShala",
    JobPackage: "Tailored Solutions - Employer's Packages at JobzShala",
    EditProfile: "Keep it Up-to-Date - Update Recruiter Profile at JobzShala",
    JobList: "Your Posted Jobs - Posted Jobs List at JobzShala",
    KycForm: "Submit KYC Details - KYC Form at JobzShala",
    RecruiterGuidelines: 'Best Practices - Recruiter Guidelines at JobzShala',
    TransactionHistory: 'Track Transactions - Transaction History at JobzShala',
    EditRegularJob: 'Modify Regular Job - Edit Regular Job at JobzShala ',
    ViewProfile: 'Your Professional Profile - View Profile at JobzShala ',
    DirectPost: 'Instant Job Posting - Job Post at JobzShala ',
    ThankYou: 'Thank You for Choosing Us - Thank You at JobzShala',
    Page404: 'Page Not Found - JobzShala',
    Settings: 'Adjust Your Preferences - Settings at JobzShala',
    Security: 'Prioritize Security - Security at JobzShala',
    UpdatePin: 'Update Your PIN - Update Pin at JobzShala',
    ManageSubuser: 'Manage Subusers - ManageSubusers at JobzShala',
    UserCreate: 'Create User Account - UserCreate at JobzShala',
    UserList: 'List of Users - UserList at JobzShala',
    SuccessPayment: 'Payment Successful - Success Payment at JobzShala',
    PaymentFailse: 'Payment Failed - Payment Failse at JobzShala',
    PaymentProcessing: 'Processing Payment - Payment Processing at JobzShala',
    FutureHiringList: "Explore Future Opportunities - Hiring List at JobzShala",
    ATS_CANDIDATE_ONBOARD: 'Streamlined Onboarding - Candidate Onboard at JobzShala',
    CreateYourFuturePlan: 'Shape Your Future - Create Your Future Plan at JobzShala'
}
const version = {
    web: 1.1
}


const keys = {
    kycVerified: 'kyc.hiring.jobzShala.com' + '_' + version.web,
    token: 'tk.hiring.jobzShala.com' + '_' + version.web,
    userDetails: 'ud.hiring.jobzShala.com' + '_' + version.web,
    registration_ref: 'registration_ref.hiring.jobzshala.com' + '_' + version.web,
    jobPostingSession: 'oppurtunity_posting.hriring.jobzshala.com' + '_' + version.web,
    skippedDemoBanner: 'br.hriring.jobzshala.com' + '_' + version.web,


    remeber_me: 'REMEMBER_ME',
    loggedIn: 'LOGIN_TIME',
    Job_Responses_Session: 'JOB_RESPONSE_SESSION',
    Featured_Job_Post_Session: 'FEATURED_JOB_POST_SESSION',
    Premium_Job_Post_Session: 'PREMIUM_JOB_POST_SESSION',

}


const currency = {
    indianRupee: '₹'
}

export default {
    component, keys, version, currency, title
    // , IR_STATUS, hostEmail , status
}

